import { Colors } from "@/enums/Colors";
import { DocumentQAMetadata } from "@/models/ai-chat/LazoChatMessage";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "next/link";
import { SetURLSearchParams } from "react-router-dom";
import LazoTooltip from "../utils/LazoTooltip";

export function generateDocumentSources(documents: DocumentQAMetadata[], setSearchParams: SetURLSearchParams) {
  function onClick(ev: React.MouseEvent<HTMLAnchorElement, MouseEvent>, documentId: number) {
    // Prevent link from executing
    ev.preventDefault();

    // Update params to reflect document id
    setSearchParams((prev) => {
      return { ...Object.fromEntries(prev.entries()), documentId: String(documentId) };
    });
  }

  return (
    <>
      <Box borderTop={`1px solid ${Colors.LIGHT_GRAY_DEDEE1}`} padding={"0.5rem 0 0.5rem 0"}>
        <Typography fontWeight="600" paddingBottom="0.25rem">
          Sources
        </Typography>
        {documents.map((d) => (
          <Box key={d.documentId} width="100%">
            <LazoTooltip title={d.name} offset={[0, 40]}>
              {/* Ignore href, only set so it doesn't warn */}
              <Link onClick={(ev) => onClick(ev, d.documentId)} href={""} target={"_blank"}>
                <Typography textOverflow="ellipsis" maxWidth="100%" overflow="hidden" whiteSpace="nowrap">
                  {d.name}
                </Typography>
              </Link>
            </LazoTooltip>
          </Box>
        ))}
      </Box>
    </>
  );
}
